import React from 'react';

const ServiceContext = React.createContext();

export default ServiceContext;
